import { useContext } from "react"
import { useQueryClient } from "@tanstack/react-query"
import { Client } from "viem"
import {
  useWaitForTransactionReceipt,
  useWalletClient,
  useWriteContract,
} from "wagmi"

import { FlowContext } from "../../context"

const useWriteContractAndWaitForTransaction = (chainId: number) => {
  const { queryKey, data: walletClient } = useWalletClient({ chainId })
  const queryClient = useQueryClient()

  const { isBitcoinFlow } = useContext(FlowContext)
  const config = isBitcoinFlow ? { getClient: () => walletClient! } : undefined

  const { data: txHash, ...rest } = useWriteContract({
    // @ts-expect-error We will wait for the wallet client in the `onMutate` fn
    // and we will check if is actually available.
    config,
    mutation: {
      onMutate: async () => {
        // Wait for the wallet client in case it hasn't been initialized yet.
        // This function will fire before the mutation function is fired.
        const cachedWalletClient = await queryClient.fetchQuery<
          Client | undefined
        >({
          queryKey,
        })

        if (!cachedWalletClient) {
          throw new Error("Wallet client not available")
        }
      },
    },
  })

  const { isLoading: isWaitingForTxReceipt, isSuccess: isTxConfirmed } =
    useWaitForTransactionReceipt({
      hash: txHash,
      chainId,
    })

  return {
    ...rest,
    isWaitingForTxReceipt,
    isTxConfirmed,
    txHash,
  }
}

export default useWriteContractAndWaitForTransaction
